import cookie from '../../utils/Tools/index'
import { deepCopy } from '../../utils/Tools/assist'
const spaceName = 'proct'
export default {
  data () {
    return {
      [`${spaceName}ShouldLoadOnMount`]: true, // proctShouldLoadOnMount
      [`${spaceName}LoadingMode`]: 1, // proctLoadingMode 0:没有全屏Loading，1:全屏Loading
      [`${spaceName}Loading`]: false, // proctLoading
      [`${spaceName}tree`]: [], // procttree
      [`${spaceName}ExpandKeys`]: [], // proctExpandKeys
      [`${spaceName}Props`]: { // proctProps
        children: 'children',
        label: 'name'
      },
      [`${spaceName}FirstNode`]: '', // proctFirstNode
      [`${spaceName}Check`]: false// proctCheck
    }
  },
  methods: {
    [`${spaceName}getTreeData`] () { // proctgetTreeData
      let userId = cookie.getCookie('UserId') // 获取userId
      // let url = `SpaceOrg/getCityAndProject?userId=${userId}`
      this[`${spaceName}Loading`] = true
      this.$store.dispatch('GetCityProjectAllData', { userId: userId, loading: this[`${spaceName}LoadingMode`] }).then(resA => {
        const res = deepCopy(resA)
        this[`${spaceName}Loading`] = false
        if (res) {
          this[`${spaceName}tree`] = this[`${spaceName}formatTreeData`]([res])
        } else {
          this[`${spaceName}tree`] = []
        }
        this[`${spaceName}ExpandKeys`].length = 0
        this[`${spaceName}initExpand`]()
        this[`${spaceName}SetTreeDataToStore`]()
      }).catch(e => {
        this[`${spaceName}Loading`] = false
      })
    },
    [`${spaceName}initExpand`] () { // proctgetinitExpand
      this[`${spaceName}tree`].map(a => {
        this[`${spaceName}ExpandKeys`].push(a.id)
      })
    },
    [`${spaceName}SetTreeDataToStore`] () {
      this.$store.commit('setTreeListData', this[`${spaceName}tree`])
    },
    findTree (arr, id) {
      const defaultArr = arr || this[`${spaceName}tree`]
      var obj = ''
      defaultArr.forEach(o => {
        if (o.id === id) {
          obj = o
        }
        if (Array.isArray(o.downdistrict) && o.downdistrict.length > 0 && !obj) {
          obj = this.findTree(o.downdistrict, id)
        }
      })
      return obj
    },
    [`${spaceName}formatTreeData`] (arry) {
      arry.forEach(o => {
        o.children = []
        if (this[`${spaceName}Check`]) {
          if (o.spatialCode >= 200000000 && o.spatialCode < 300000000) {
            o.disabled = false
          } else {
            o.disabled = true
          }
        }
        if (Array.isArray(o.downdistrict) && o.downdistrict.length > 0) {
          o.children = o.children.concat(this[`${spaceName}formatTreeData`](o.downdistrict))
          delete o.downdistrict
        }
        if (Array.isArray(o.downproject) && o.downproject.length > 0) {
          o.children = o.children.concat(this[`${spaceName}formatTreeData`](o.downproject))

          if (this[`${spaceName}FirstNode`] === '') {
            this[`${spaceName}FirstNode`] = o.downproject[0]
          }
          delete o.downproject
        }
      })
      return arry
    }
  },
  mounted () {
    if (this[`${spaceName}ShouldLoadOnMount`]) this[`${spaceName}getTreeData`]()
  }
}



// WEBPACK FOOTER //
// ./src/pages/mixins/proctTree.js